<template>
    <div>
        <b-row>
            <b-col md="12">
                    <b-card>
                        <b-row>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('faculty_code')">
                                    {{ formData.faculty_code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('department_code')">
                                    {{ formData.department_code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_code')">
                                    {{ formData.code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_name')">
                                    {{ getLocaleText(formData, 'name') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_level')">
                                    {{ getLocaleText(formData, 'level_text') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_language')">
                                    {{ formData.language }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_duration')">
                                    {{ formData.duration }}
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
        </b-row>
        <b-row>
            <b-col md="12" class="mt-2">
                <b-card>
                    <b-row>
                        <b-col md="6">
                            <b-form-group :label="$t('semester')">
                                <semesters-selectbox
                                    v-model="semesterId"/>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-alert variant="info" show>{{ $t('ects_values_info') }}</b-alert>
                        </b-col>
                        <b-col md="12">
                            <b-table
                                :empty-filtered-text="$t('no_result')"
                                :empty-text="$t('no_result')"
                                bordered
                                striped
                                responsive
                                :items="tableData"
                                :fields="tableFields"
                                show-empty
                                class="mb-5 mt-2 table-dropdown no-scrollbar border rounded">
                                <template v-for="(item, index) in tableFields" v-slot:[`head(${item.key})`]="data">
                                    <span v-if="index != 0" class="cursor-pointer" v-b-tooltip.hover :title=item.label>{{ item.key }}</span>
                                    <span v-else>{{ item.label }}</span>
                                </template>
                                <template v-for="(item, index) in tableData[0]" v-slot:[`cell(${item.rank})`]="data">
                                    <multi-selectbox
                                        :key="data.item[index].id"
                                        :options="statusOptions"
                                        :multiple="false"
                                        @input="saveData(data)"
                                        v-if="data.item[index]"
                                        :id="'b-input-'+(index)+'-'+data.item[index].id"
                                        v-model="data.item[index].value" />
                                </template>
                                <template #cell(info)="row">
                                    <span>{{row.item.info}}</span><br>
                                    <b-badge class="cursor-pointer" variant="dark" @click="openCourseProgramRealtion(row)">{{$t('ects_course_program_relation').toUpper()}}</b-badge>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// Components
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"

// Services
import EctsService from "@/services/EctsService"
import ProgramOutcome from "@/services/ProgramOutcome"

// Pages

// Other
import { ValidationObserver, ValidationProvider } from "vee-validate";
import qs from "qs";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        MultiSelectbox,
        SemestersSelectbox
    },
    props: {
        program: {
            type: Object,
        },
    },
    data() {
        return {
            formData: {},
            statusOptions: [
                {
                    value: "0",
                    text: "-"
                },
                {
                    value: "1",
                    text: "1"
                },
                {
                    value: "2",
                    text: "2"
                },
                {
                    value: "3",
                    text: "3"
                },
                {
                    value: "4",
                    text: "4"
                },
                {
                    value: "5",
                    text: "5"
                }
            ],
            tableData: [],
            tableFields: [
                {
                    key: 'info',
                    label: this.$t('ects_course_program_outcomes')
                }
            ],
            semesterId: null
        };
    },
    created() {
        this.formData = this.program
    },
    watch: {
        semesterId: {
            handler(value) {
                if(value) {
                    this.tableFields = [{
                        key: 'info',
                        label: this.$t('ects_course_program_outcomes')
                    }]
                    this.tableData = []
                    this.getData()
                }
            },
            immediate: true
        }
    },
    methods: {
        getData(){
            const config = {
                params: {
                    filter: {
                        program_code: this.program.code,
                        semester_id: this.semesterId
                    },
                    sort: 'id',
                    limit: -1
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            ProgramOutcome.getAll(config).then(response => {
                response.data.data.forEach(item => {
                    this.tableFields.push({
                        key: item.rank.toString(),
                        label: this.getLocaleField(item.name),
                        program_outcome_id: item.id,
                        rank: item.rank
                    })
                })
            }).finally(() => {
                this.getCoursesData()
            }).catch(e => {
                this.showErrors(e)
            })
        },

        getCoursesData(){
            this.tableData = []
            EctsService.getProgramCoordinatorCourses().then(response => {
                response.data.data.forEach(itm => {
                    let objData = {}
                    this.tableFields.forEach((item, i) => {
                        if(i > 0){
                            objData[i] = {
                                id: itm.id,
                                program_outcome_id: item.program_outcome_id,
                                value: "0",
                                rank: item.rank
                            }
                        }
                    })
                    this.tableData.push({
                        course_data: itm,
                        info: itm.code+' '+this.getLocaleText(itm, 'name'),
                        ...objData
                    })
                })
            }).finally(() => {
                this.getComputeData()
            }).catch(e => {
                this.showErrors(e)
            })
        },

        getComputeData(){
            EctsService.getProgramCoordinatorCourseProgramOutcomes(this.semesterId).then(response => {
                response.data.data.forEach(itm => {
                    this.tableData.forEach((item,index) => {
                        Object.keys(item).forEach((key) => {
                            if(typeof item[key] == "object" && item[key].program_outcome_id == itm.program_outcome_id && item[key].id == itm.course_id){
                                this.tableData[index][key].value = itm.value
                                this.tableData[index][key].course_program_outcome_id = itm.id
                            }
                        })
                    })
                })
            }).catch(e => {
                this.showErrors(e)
            })
        },

        saveData(data) {
            Object.keys(data.item).forEach((key) => {
                if(data.item[key].program_outcome_id == data.field.program_outcome_id && data.item[key].rank == data.field.rank){
                    let workData = data.item[key]

                    if(workData.hasOwnProperty('course_program_outcome_id') && workData.value == "0"){
                        EctsService.deleteProgramCoordinatorCourseProgramOutcomes(workData.course_program_outcome_id).then(response => {
                            this.$toast.success(this.$t('api.'+response.data.message))
                        }).finally(() => {
                            this.getCoursesData()
                        }).catch(e => {
                            this.showErrors(e, null)
                        })
                    } else if(workData.hasOwnProperty('course_program_outcome_id') && workData.value != "0"){
                        let formData = {
                            course_id: workData.id,
                            program_outcome_id: workData.program_outcome_id,
                            value: workData.value
                        }
                        EctsService.updateProgramCoordinatorCourseProgramOutcomes(workData.course_program_outcome_id,formData).then(response => {
                            this.$toast.success(this.$t('api.'+response.data.message))
                        }).finally(() => {
                            this.getCoursesData()
                        }).catch(e => {
                            this.showErrors(e, null)
                        })
                    } else {
                        let formData = {
                            course_id: workData.id,
                            program_outcome_id: workData.program_outcome_id,
                            value: workData.value,
                            semester_id: this.semesterId
                        }
                        EctsService.storeProgramCoordinatorCourseProgramOutcomes(formData).then(response => {
                            this.$toast.success(this.$t('api.'+response.data.message))
                        }).finally(() => {
                            this.getCoursesData()
                        }).catch(e => {
                            this.showErrors(e, null)
                        })
                    }
                }
            })
        },

        openCourseProgramRealtion(row){
            row.item.course_data.semester_id = this.semesterId
            row.item.course_data.program_program_code = this.program.code
            this.$emit('openCourseDetail', row.item.course_data, 'course-program-outcome-matrix')
        }

    },
}
</script>
<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.multiselect__content-wrapper {
    position: absolute !important;
    top: 100% !important;
    bottom: auto !important;
    display: block !important;
}
.table-responsive {
    overflow: visible !important;
}
.table-dropdown {
    overflow: visible !important;
}
</style>
